import { useContext, useEffect, useState } from "react"

import { ApplicationContext } from 'context'

import Layout from "components/Layout"
import InventoryDashboard from "components/InventoryDashboard"
import InventoryPowerPacks from "components/InventoryPowerPacks"
import InventoryReports from "components/InventoryReports"
import ReportBuilder from "components/ReportBuilder"

// import styles from "./styles.module.scss"

const Inventory = (props) => {
  const { contextAgency, contextError, contextLoading, useCurrentPath } = useContext(ApplicationContext)
  const [isLoading, setIsLoading] = contextLoading // eslint-disable-line
  const [_, setError] = contextError // eslint-disable-line
  const [agency] = contextAgency // eslint-disable-line

  const [tab, setTab] = useState('DASHBOARD')

  const currentPath = useCurrentPath()

  let surety = null
  if (agency?.sureties?.length > 0) {
    surety = agency.sureties[0]
  }

  useEffect(()=> {
    if(currentPath === '/inventory') {
      setTab('DASHBOARD')
    } else if (currentPath === '/inventory/power-packs') {
      setTab('POWER_PACKS')
    } else if (currentPath === '/inventory/powers') {
      setTab('POWERS')
    } else if (currentPath === '/inventory/reports') {
      setTab('REPORTS')
    } else if (currentPath === '/inventory/report/:reportId') {
      setTab('REPORT_BUILDER')
    }
  }, [currentPath])

  if (agency) {
    return (
      <Layout>
        {tab === 'DASHBOARD' && <InventoryDashboard surety={surety} />}
        {tab === 'POWER_PACKS' && <InventoryPowerPacks surety={surety} />}
        {tab === 'REPORTS' && <InventoryReports surety={surety} />}
        {tab === 'REPORT_BUILDER' && <ReportBuilder surety={surety} />}
      </Layout>
    )
  }
  return null
}

export default Inventory
